export class AuditSearchRequestDTO {

  auditId: string;
  organizationId: string;  // tenant id
  userId: string;  // altId
  practitionerNpi: string;
  startDateTime: string;
  endDateTime: string;
  count: number; // max value 200
  page: number;

}
